export enum CalendarEntryStatus {
  Upcoming = 'upcoming',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export interface CalendarEntry {
  id: string;
  title: string;
  subtitle?: string;
  scheduledAt: Date | string;
  description?: string;
  category?: string;
  status: CalendarEntryStatus;
  pinned?: boolean;
  relatedTaskId?: number;
}
